import React from "react";
import style from "./ImgBorder.module.css";
import circle from "../../../assets/img/circulogris.png";

const ImgBorder = ({
  onClick = () => {},
  width = "2vw",
  borderWidth,
  color,
  src,
}) => {
  return (
    <div
      style={{
        "--width": width,
        "--width-border": borderWidth,
        "--border-color": color,
      }}
      className={style.content}
    >
      {src ? (
        <img
          onClick={onClick}
          alt="img"
          className={style.img}
          onError={(e) => (e.target.src = circle)}
          src={src}
        />
      ) : (
        <img onClick={onClick} alt="img" className={style.img} src={circle} />
      )}
    </div>
  );
};

export default ImgBorder;
